import type { IProfile } from "@/data/model/Profile";

import { trans } from "@/app/localization/Trans";
import { Helper } from "@/app/ui/Helper";
import { Popup } from "@/app/ui/Popup";

export class AvatarInput {
    private $element: JQuery;
    private $preview: JQuery;
    private $input: JQuery;
    private pendingFile?: File;
    private cachedProfile?: IProfile;

    constructor() {
        this.$element = $('<div class="avatarinput" />');
        this.$preview = $('<div class="preview" />').appendTo(this.$element);
        this.$input = $('<input type="file" />').appendTo(this.$element);
        this.$input.change(() => {
            this.validateAndSet(this.$input.prop("files"));
        });
    }

    public setByProfile(profile: IProfile) {
        this.cachedProfile = profile;

        this.$preview.removeAttr("style").removeClass("border");
        if (profile.avatar !== undefined)
            this.$preview.css("background-image", "url('" + profile.avatar + "')").empty();
        else
            this.$preview
                .addClass("border")
                .html('<div class="shortname">' + Helper.shortNameFromProfile(profile) + "</div>");

        let edit = this.$element.find("> .edit");
        if (edit.length === 0) edit = $('<div class="edit">' + trans.general.edit + "</div>").appendTo(this.$element);
        else edit.html(trans.general.edit);

        edit.unbind("click").bind("click", () => {
            this.$input.trigger("click");
        });

        this.$preview.unbind("click").bind("click", () => {
            this.$input.trigger("click");
        });
    }

    public getPendingUpload(): File | undefined {
        return this.pendingFile;
    }

    public appendTo($element: JQuery): AvatarInput {
        this.$element.appendTo($element);

        return this;
    }

    private validateAndSet(fileList: FileList) {
        const file = fileList[0];
        if (file === undefined) return;

        if (file.type.toLowerCase().indexOf("image") === -1) {
            Popup.show(trans.profile.onlyImageFiles);
            return;
        }

        this.setPendingUpload(file);
    }

    private setPendingUpload(file: File) {
        this.pendingFile = file;

        //set avatar based on file
        const reader = new FileReader();
        reader.onload = () => {
            this.$preview
                .removeClass("border")
                .css("background-image", "url('" + reader.result + "')")
                .empty();
        };

        reader.readAsDataURL(file);

        let edit = this.$element.find("> .edit");
        if (edit.length === 0) edit = $('<div class="edit"><i class="fas fa-ban"></i></div>').appendTo(this.$element);
        else edit.html('<i class="fas fa-ban"></i>');

        this.$preview.unbind("click").bind("click", () => {
            this.setByProfile(this.cachedProfile!);
        });

        edit.unbind("click").bind("click", () => {
            this.setByProfile(this.cachedProfile!);
        });
    }
}
